import React, {Component} from 'react';

import strings from 'strings';

import ReadyButton from 'components/ReadyButton';
import AudioPlayer from 'components/AudioPlayer';

import {nn_intro, no_intro} from './assets';
import listen from 'assets/listen.png';

class Intro extends Component {
	constructor(props) {
		super(props);

		this.state = {isShowingPractiseTests: false};

		switch (strings.getLanguage()) {
			case 'nn':
				this.assets = nn_intro;
				break;
			case 'no':
			default:
				this.assets = no_intro;
				break;
		}
	}

	componentWillReceiveProps(newProps) {
		if (this.props.currentStep !== newProps.currentStep) {
			if (newProps.currentStep || newProps.currentStep === 0) {
				this.setState({
					currentStep: newProps.currentStep,
				});
			}
		}
	}

	getTaskAudio = (step) => {
		switch (step) {
			case 1:
				return this.assets.task1;
			case 2:
				return this.assets.task1a;
			default:
				return null;
		}
	};

	render() {
		const {currentStep} = this.props;

		let currentTaskAudio = this.getTaskAudio(currentStep);
		const {ageGroup} = this.props;
		const isNormingTest = ageGroup >= 2;
		return (
			<>
				{currentStep === 0 && (
					<>
						<p>
							<AudioPlayer
								autoplay
								inline
								src={this.assets.intro}
							/>
							{strings.pd_intro1}
						</p>
						{!isNormingTest && (
							<ReadyButton onReadyChange={this.props.setReady} />
						)}
					</>
				)}
				{currentStep > 0 && currentStep < 3 && (
					<div className="WorkingMemory">
						<img className="listen-image" src={listen} alt="" />
						<AudioPlayer
							key={currentStep}
							autoplay
							inline
							src={currentTaskAudio}
						/>
					</div>
				)}
				{currentStep === 3 && (
					<>
						<p>
							{isNormingTest
								? strings.pd_introDone_norming
								: strings.pd_introDone}
						</p>
						{!isNormingTest && (
							<ReadyButton onReadyChange={this.props.setReady} />
						)}
					</>
				)}
			</>
		);
	}
}

export default Intro;
